<script>
    import { onMount } from 'svelte'
    import Fa from 'svelte-fa'
    import {link,push,querystring} from 'svelte-spa-router'
    import * as qs from 'qs';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faUserPlus,faHomeUser,faSignIn,faPhone,faKey,faMobileRetro } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    import { triggerPush, resetSnoozeOnLogin } from '../push'
    let access_token = window.localStorage.getItem('access_token')

    // ถ้า login อยู่แล้วเปิดหน้านี้ (เช่นกดกลับหน้าแรก) → ไป dashboard เลย ไม่ต้อง login ซ้ำ
    // token หมดอายุ Dashboard จะ clear แล้วเด้งกลับมาเอง (ไม่ loop)
    onMount(() => {
        const t = window.localStorage.getItem('access_token')
        if (t && t !== '') push('/dashboard')
    })
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let myLink = '/register'

    let username = ""
    let password = ""

    let paramsx = new URLSearchParams($querystring);
	let logintoken = paramsx.get('token')
    
    async function Login(){
        if(username==''){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถเข้าสู่ระบบได้!',
                text: 'กรุณาหรอกข้อมูล เบอร์โทรศัพท์',
                icon: 'warning',
                confirmButtonText: 'OK' 
            })
            var usernames = document.getElementById('usernames');
            usernames.focus();
            return false;
        }
        if(password==''){
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถเข้าสู่ระบบได้!',
                text: 'กรุณาหรอกข้อมูล รหัสผ่าน',
                icon: 'warning',
                confirmButtonText: 'OK' 
            })
            var passwords = document.getElementById('passwords');
            passwords.focus();
            return false;
        }
        let dataLogin = {
                password:password,
                web_id:window.localStorage.getItem("appid")
            }
        const res = await fetch(window.localStorage.getItem("apiurl")+"auth/login", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: qs.stringify({
                username:username,
                password:JSON.stringify(dataLogin)
            })
        })

        const json = await res.json()

        if (json.statusCode==200) {
            window.localStorage.setItem("access_token",json.access_token)
            // setToken(json.access_token)
            push('/dashboard')
            // login สำเร็จ → ล้าง snooze เฉพาะถ้าเป็นคนละ user, แล้วให้ PushPrompt เด้ง
            resetSnoozeOnLogin()
            triggerPush()
			return json;
		} else {
            Swal.fire({
                heightAuto: false,
                title: 'ไม่สามารถเข้าสู่ระบบได้!',
                text: 'กรุณาตรวจสอบข้อมูล',
                icon: 'error',
                confirmButtonText: 'OK' 
            })
            throw new Error(json);
		}
    }
</script>
<div class="row pt-2"> 
    <div class="col-6">
        <a href="{dataSetting.homepage}" class="btn btn-outline-secondary btn-sm btn-gd top-home-df" style="--bs-btn-padding-y: .10rem; --bs-btn-padding-x: .3rem; --bs-btn-font-size: .7rem;"><Fa icon={faHomeUser} /> หน้าหลัก</a>
        {#if access_token}
            <a href="{dataSetting.homepage}" class="btn btn-outline-secondary btn-sm btn-gd top-home" style="--bs-btn-padding-y: .10rem; --bs-btn-padding-x: .3rem; --bs-btn-font-size: .7rem;display:none;"><Fa icon={faHomeUser} /></a>
        {:else}
            <a href="/" class="btn btn-outline-secondary btn-sm btn-gd top-home" style="--bs-btn-padding-y: .10rem; --bs-btn-padding-x: .3rem; --bs-btn-font-size: .7rem;display:none;"><Fa icon={faHomeUser} /></a>
        {/if}
        
    </div>
    <div class="col-6 text-end">
        <a href="{dataSetting.lineurl}" target="_blank"><span class="badge rounded-pill text-bg-success"><Fa icon={faLine} size="lg"/> {dataSetting.lineid}</span></a>
    </div>
    
    <div class="col-3 mt-5"></div>
    <div class="col-6 text-center mt-4 mb-3">
        <img src="{dataSetting.logo}" class="img-fluid">
        
    </div>
    <div class="col-12 text-center"><h5 class="text-login">เข้าสู่ระบบ</h5></div>
    <div class="col-12 mt-3"  data-aos="fade-up">
        <div class="card">
            <div class="card-body">
                <div class="mb-3">
                    <label class="form-label">เบอร์โทรศัพท์</label>
                    <div class="form-icon">
                        <input type="text" class="form-control rounded-pill text-center form-control-icon" id="usernames" placeholder="" bind:value={username} autocomplete="off">
                        <Fa icon={faMobileRetro} size="lg"/>
                        
                    </div>
                </div>
                <div class="mb-1">
                    <label class="form-label">รหัสผ่าน</label>
                    <div class="form-icon">
                        <input type="password" class="form-control rounded-pill text-center form-control-icon" id="passwords" placeholder="" bind:value={password}  autocomplete="off">
                        <Fa icon={faKey} size="lg"/>
                    </div>
                    <div class="col-12 mt-1" style="text-align: right;">
                        <a href="{'javascript:;'}" on:click={() => push('/resetpassword')}  class="text-info" style="text-decoration: none;font-size:10px;color:#FFF !important;">ลืมรหัสผ่าน</a>
                    </div>
                    
                </div>
                <div class="row">
                    <div class="col-12 text-center d-grid gap-2">
                        <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => Login()} ><Fa icon={faSignIn} /> เข้าสู่ระบบ</button>
                    </div>
                    <div class="col-12">
                        <hr class="mt-3 mb-2" style="border-top: 0.5px solid rgba(52, 52, 52, 0.1);"/>
                    </div>
                    <div class="col-6 text-end" style="position: relative;">
                        <img src="../assets/images/clicks.gif" class="img-rst">
                        <button on:click={() => push('/register')} type="button" class="btn mr-2 btn-warning rounded-pill btn-sm btn-home-register" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"><Fa icon={faUserPlus} /> สมัครสมาชิก</button>
                    </div>
                    <div class="col-6">
                        <button on:click={() => window.location.href = dataSetting.lineurl} type="button" class="btn btn-outline-secondary rounded-pill btn-home-admin" style="--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .75rem;"><Fa icon={faLine} size="lg"/> <span>ติดต่อเจ้าหน้าที่</button>
                    </div>
                </div>
            </div>
          </div>
    </div>
</div>
<style>
    :global(.themes.darkred>.row){
        margin-left: 0px !important;
        margin-right: 0px !important;
    }
    :global(.themes.darkred>.row .card){
        padding: 10px 20px 10px 20px !important;
    }
</style>
